import type { CopyShape } from "@tami/core/intl";

import type { WORKFLOW_SCRIPT_COPY_PT_BR } from "../workflow-script.copy";

export const WORKFLOW_SCRIPT_COPY_ES_ES: CopyShape<typeof WORKFLOW_SCRIPT_COPY_PT_BR> = {
  wfIntro: {
    narrative: "Organiza tu flujo de producción en Kanban — de la idea al contenido publicado, sin perder el hilo.",
  },
  wfKanban: {
    narrative: "Cada tarjeta muestra plataforma, formato y plazo. Arrastra entre columnas para avanzar el estado.",
    callout: "Kanban de producción: arrastra las tarjetas del borrador hasta el publicado.",
  },
  wfOverview: {
    narrative: "Mira de un vistazo cuántos contenidos están en idea, producción, revisión o listos para salir.",
  },
  wfOutro: {
    narrative: "Rutina organizada más allá del calendario — listas y flujo en el mismo sitio.",
  },
};
